

import React from 'react';
import { Spin } from 'antd';
import './style.scss'; // Estilo personalizado

interface GlobalLoadingProps {
  isVisible: boolean;
}

const GlobalLoading: React.FC<GlobalLoadingProps> = ({ isVisible }) => {
  if (!isVisible) return null;
  return (
    <div className="global-loading-overlay">
      <Spin size="large" />
    </div>
  );
};

export default GlobalLoading;

